module.exports = __webpack_public_path__ + "img/honda.d1639829.png";